const getCurrentLevel = (state, moduleId) => {
   if (state.activeExercise.levelSelect) {
      return state.activeExercise.levelSelect.level;
   }

   let { currentLevel } = moduleId
      ? state.activeExercise.modules[moduleId].progress
      : state.activeExercise.progress;

   // const subData =
   //    state.appData.permissions?.subscriptionAndPurchases?.subscription;

   // let isSubscribed = false;
   // if (subData) {
   //    if (
   //       new Date(subData.expiration) > Date.now() &&
   //       subData.includes.includes('exercise')
   //    ) {
   //       isSubscribed = true;
   //    }
   // }

   const isSubscribed = true;

   if (!isSubscribed) {
      currentLevel = Math.min(
         currentLevel,
         moduleId
            ? state.activeExercise.modules[moduleId].exerciseDocument
                 .maxUnpaidLevel
            : state.activeExercise.exerciseDocument.maxUnpaidLevel
      );
   }

   return currentLevel;
};

export { getCurrentLevel };
